export const InboundIframeIdSelector = {
  WINDOW: 'third-party-window-iframe',
  REMOTE: 'third-party-remote-iframe'
};